import { render, staticRenderFns } from "./foodrecipesdetails.vue?vue&type=template&id=3e423ed2"
import script from "./foodrecipesdetails.vue?vue&type=script&lang=js"
export * from "./foodrecipesdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports